module.exports = __webpack_public_path__ + "img/checklist-icon.9d6940d7.svg";